import { DatePipe } from '@angular/common';

const _datePipe: DatePipe = new DatePipe('en-US');
const ACTION_TYPE = {
    'd': 'Delete',
    'r': 'Read',
    'c': 'Create',
    'u': 'Update'
};
const WHERE_TYPE = {
    'w': 'Web',
    'd': 'Desktop',
    'i': 'iPhone',
    'r': 'REST API',
    'e': 'Email Deposit'
};

const LINK_TYPE = {
    'Note': 'entry',
    'File': 'entry',
    'Entity': 'entity',
    'Contact': 'contact'
};

export const COLUMNDEFS = [{
    headerName: 'Users',
    valueGetter: (params) => {
        return params.data.user.link.phid;
    },
    tooltipValueGetter: (params) => params.value,
    colId: 'user',
    field: 'user',
    menuTabs: []
}, {
    headerName: 'Where',
    valueGetter: (params) => {
        return WHERE_TYPE[params.data.where] || params.data.where;
    },
    tooltipValueGetter: (params) => params.value,
    colId: 'where',
    field: 'where',
    menuTabs: [],
}, {
    headerName: 'Date & Time',
    cellRenderer: (params) => {
        return _datePipe.transform(params.value, 'dd MMM yyyy, HH:mm');
    },
    tooltipValueGetter: (params) => params.value,
    colId: 'operate_time',
    field: 'time',
    menuTabs: [],
    sort: 'desc' as 'desc' // Ensure sort is assigned the correct type
}, {
    headerName: 'Action',
    valueGetter: (params) => {
        return ACTION_TYPE[params.data.type] || params.data.type;
    },
    tooltipValueGetter: (params) => params.value,
    colId: 'type',
    field: 'type',
    menuTabs: []
}, {
    headerName: 'Object Type',
    valueGetter: (params) => {
        return params.data['object-type'];
    },
    tooltipValueGetter: (params) => params.value,
    colId: 'object-type',
    field: 'object-type',
    menuTabs: []
}, {
    headerName: 'Details',
    sortable: false,
    valueGetter: (params) => {
        return params.data.detail.name;
    },
    cellRenderer: (params) => {
        if (params.data.detail.link && params.data.detail.name) {
            const srcType = LINK_TYPE[params.data['object-type']];
            const srcId = params.data['object-id'];
            return `<a href='${srcType}/${srcId}' target='_blank'>${params.data.detail.name}</a>`;
        }
        return '';
    },
    tooltipValueGetter: (params) => params.value,
    colId: 'detail',
    field: 'detail',
    menuTabs: []
}];
